<template>
  <div :class="this.$route.path == '/index'?'scollps':''" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import {listCategory} from './api/resource'
  import {getUrl} from './utils/plugin/ipCode'

  export default {
    name: "app",
    data() {
      return {};
    },
    methods: {
      unloadFn(e) {
        sessionStorage.removeItem('senior')
        // sessionStorage.removeItem('sublibrary')
        sessionStorage.removeItem('classification')
        sessionStorage.removeItem('category')
      },
      categInit() {
        return new Promise((reject, provide) => {
          listCategory({
            typeId: this.$store.state.typeId,
          }).then(res => {
            if (res.data.code == 200) {
              reject(res.data.data)
            }
          })
        })
      },
    },
    async mounted() {
      window.addEventListener("beforeunload", e => {
        sessionStorage.removeItem('esParams')
        // sessionStorage.removeItem('sublibrary')
        // this.unloadFn(e);
      });
      let pas = await this.categInit()
      this.$store.dispatch('setCategoryData', pas)
    },
    destroyed() {
      window.removeEventListener("beforeunload", e => {
        this.unloadFn(e);
      });
    },
    created() {
      let that = this
      getUrl("https://api.ipify.org/?format=json", function (data) {
        data = JSON.parse(data);
        sessionStorage.setItem('publicIp', data.ip)
      });
      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload", () => {
        localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
      });
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("messageStore") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("messageStore"))
        )
      );
    },
  };
</script>

<style lang="less" scoped>

  .app {
    width: 100%;
    height: 100%;
  }

  .scollps {
    height: 100%;
    position: relative;
    overflow: hidden;

    // scroll-snap-type: y mandatory;
  }

  //   font-family: LiSu;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: hsl(210, 29%, 24%);
  //   height: 100%;
  //   font-size: 12px;
  // }

</style>
